import {CampaignTypes} from "../../../../../types/src";

function getCampaignName(type: CampaignTypes) {
  switch (type) {
    case CampaignTypes.AcquisitionCsvInstantly:
      return 'Instantly';
    case CampaignTypes.AcquisitionCsvRb2b:
      return 'RB2B';
    case CampaignTypes.AcquisitionCsvSquid:
      return 'Squid';
    default:
      return '';
  }
}

export const getIntegratedCampaignTooltip = (show: boolean, campaignType: CampaignTypes) => {
  if (!show) return '';
  return `You already have a Website Visitors by ${getCampaignName(campaignType)} campaign enabled. Please archive the existing one, to create a new one.`;
};
